import React from 'react';

export const AssetsIcon = (): React.JSX.Element => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 14 14"
			width="100%"
			height="auto"
		>
			<path
				fill="currentColor"
				d="M12.5 2a.5.5 0 0 0-.5-.5H9.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V1.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM6 4.5h2v-3H6zm8 7.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
			/>
		</svg>
	);
};
